import { appSelectors } from '@appStore/reducers/app'
import clsx from 'clsx'
import Badge from 'components/atoms/Badge'
import { CustomTip } from 'components/atoms/tooltipCustom'
import * as Contacts from 'features/contacts'
import * as files from 'shared/files'
import { useAppSelector } from 'shared/hooks'
import { type ContactsTable, LoadingButton, StackIcon } from 'shared/ui'

import css from './style.module.css'

export function InteractionLog({
	className,
	filters,
	unSelectAll
}: Pick<ContactsTable.Types.ActionsProps, 'filters' | 'unSelectAll'> & {
	className?: string
}) {
	const isProPlanAccessible = useAppSelector(appSelectors.isPro)

	const shouldBlock = isProPlanAccessible === false

	const [fetchCSV, { isLoading }] =
		Contacts.api.useLazyExportRecentActivitiesQuery()

	const button = (
		<LoadingButton
			className={clsx(className, shouldBlock && css.wrapper)}
			disabled={shouldBlock}
			isLoading={isLoading}
			onClick={async () => {
				const { $filter, $orderby, $searchQuery } = filters

				const { data: content } = await fetchCSV({
					$filter,
					$orderby,
					$searchQuery
				})

				unSelectAll()

				if (content) {
					files.saveFile(content, files.generateName())
				}
			}}
			variant='bordered-dark'
		>
			<StackIcon icon='csv' width={18} />
			Export Interaction Log
			{shouldBlock && <Badge />}
		</LoadingButton>
	)

	return shouldBlock ? (
		<CustomTip arrow title='Upgrade your plan to Pro'>
			{button}
		</CustomTip>
	) : (
		button
	)
}
